import { Component, inject, OnDestroy, signal } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { UserService } from 'src/app/services/user.service';
import { CheckoutHistory } from 'src/app/models/checkout-history';
import { from } from 'rxjs';
import { mergeMap, toArray } from 'rxjs/operators';
import { ConfigService } from 'src/app/services/config.service';
import { Router } from '@angular/router';
import { CustomerType } from '../../../models/client-configuration';
import { ToastService } from '../../../_core/services/toast.service';

@Component({
  selector: 'app-user-checkout-history',
  templateUrl: './user-checkout-history.component.html',
  styleUrls: ['./user-checkout-history.component.scss'],
})
export class UserCheckoutHistoryComponent implements OnDestroy {
  private readonly toastService = inject(ToastService);

  readonly showDeleteCheckoutHistoryDialog = signal<boolean>(false);

  section = 'checkouts/history';
  loading = true;
  userService: UserService;
  hasLoadMore: boolean;
  waiting: boolean;
  historyLimit = 10;
  customerType: CustomerType;
  offset = 0;

  constructor(
    userService: UserService,
    configService: ConfigService,
    router: Router,
    private apiService: ApiService,
  ) {
    this.userService = userService;

    if (!configService.get().showCheckoutHistory) {
      router.navigate(['/user/checkouts']);
    }

    this.customerType = configService.customerType;

    this.loadCheckouts(true);
  }

  ngOnDestroy() {
    this.userService.checkoutHistory = [];
  }

  loadCheckouts(isFirst: boolean) {
    if (isFirst) {
      // if it is the 1st call we reset the offset
      this.offset = 0;
    }
    this.apiService.getUserCheckoutHistory(this.userService.getUserId(), this.offset).subscribe((checkouts) => {
      // remove duplicates (subscriptions);
      if (this.offset) {
        checkouts.unshift(...this.userService.checkoutHistory);
      }
      this.userService.checkoutHistory = checkouts
        .map((c) => c.recordId)
        .map((c, i, final) => final.indexOf(c) === i && i)
        .filter((c) => checkouts[c])
        .map((c) => checkouts[c]);

      this.loading = false;
      this.waiting = false;

      // TODO: find a better solution
      setTimeout(() => checkouts.length === this.historyLimit, 500);
      this.offset += this.historyLimit;
      this.hasLoadMore = this.offset === this.userService.checkoutHistory.length;
    });
  }

  loadMore() {
    this.waiting = true;
    this.loadCheckouts(false);
  }

  deleteAll() {
    this.showDeleteCheckoutHistoryDialog.set(false);
    from(this.userService.checkoutHistory)
      .pipe(
        mergeMap((checkout) =>
          this.apiService.removeCheckoutFromHistory(this.userService.getUserId(), checkout.checkoutId)
        ),
        toArray()
      )
      .subscribe(() => {
        this.toastService.showToastSolution('messages.checkoutHistory.clear');
        this.userService.checkoutHistory = [];
      });
  }

  onRemoved(checkout: CheckoutHistory) {
    this.userService.removeCheckoutFromHistory(checkout);
  }
}
